<div>
 <app-banner></app-banner>
</div>
<div class="inner-content" >
  <router-outlet></router-outlet>
</div>

<app-loading></app-loading> 